<template>
  <button
    :disabled="disabled"
    :class="[alwaysChevron ? 'aspect-square' : 'p-2 md:p-2.5']"
    data-testid="back-button"
    type="button"
    role="button"
    class="cursor-pointer rounded-lg bg-gray-light text-center font-bold text-white transition duration-200 ease-in-out disabled:cursor-default disabled:bg-opacity-50"
  >
    <ChevronLeftIcon
      :class="{ 'md:hidden': !alwaysChevron }"
      class="h-10 w-full px-1"
    />
    <span :class="{ 'md:inline': !alwaysChevron }" class="hidden">
      <template
        v-if="configuratorStore.currentStep === ConfiguratorStep.ExtraOptions"
      >
        {{ $t('pages.navigation.footer.buttons.previous') }}
      </template>
      <template v-else>
        {{ $t('pages.navigation.footer.buttons.previous_page') }}
      </template>
    </span>
  </button>
</template>

<script setup lang="ts">
import { ChevronLeftIcon } from '@heroicons/vue/20/solid';
import { ConfiguratorStep } from '@/types/Configurator/ConfiguratorStep';
import { useConfiguratorStore } from '@/stores/Configurator/ConfiguratorStore';

const configuratorStore = useConfiguratorStore();

defineProps({
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },

  alwaysChevron: {
    type: Boolean,
    required: false,
    default: false,
  },
});
</script>
